<script setup>
import {useToastStore} from "../../store/toast.module.js";
useToastStore()
</script>
<template>
    <Toast>
        <template #message="slotProps">
            <i class="pi pi-check pt-1" style="color: green;" v-if="slotProps.message.severity==='success'"></i>
            <i class="pi pi-times-circle pt-1" style="color: #dc2626;" v-if="slotProps.message.severity==='error'"></i>
            <div class="p-toast-message-text">
                <span class="p-toast-summary">{{slotProps.message.summary}}</span>
                <div class="p-toast-detail" v-html="slotProps.message.detail" />
            </div>
        </template>
    </Toast>

    <RouterView />
</template>
